export function updateObjectNestedProperties(
  obj: any,
  propertyValueMap: Record<string, any>,
  defaultPropertyPath?: string
) {
  let updatedObject: typeof obj = { ...obj };

  for (let propertyPath in propertyValueMap) {
    const value = propertyValueMap[propertyPath];

    if (defaultPropertyPath) propertyPath = `${defaultPropertyPath}.${propertyPath}`;
    const properties = propertyPath.split('.');

    let currentObject = updatedObject;
    for (let i = 0; i < properties.length - 1; i++) {
      const property = properties[i];
      currentObject[property] = { ...currentObject[property] };
      currentObject = currentObject[property];
    }

    const lastProperty = properties[properties.length - 1];
    currentObject[lastProperty] = value;
  }

  return updatedObject;
}
